import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export { RefreshIcon };

const LoadingButton = ({ sx, isLoading, children, ...props }) => {
  // const CustomButton = styled(Button)({
  //   backgroundColor: "#250258",
  //   textTransform: "none",
  //   borderRadius: ".5rem",
  //   padding: ".5rem 1rem",
  //   color: "white",
  //   "&:hover": {
  //     backgroundColor: "#0056b3",
  //   },
  // });
  return (
    <Button
      variant="contained"
      color="primary"
      sx={{
        ...sx,
        fontFamily: "Urbane-Light",
        fontSize: "12px",
      }}
      {...props}
      disabled={isLoading || props.disabled}
      startIcon={isLoading ? <CircularProgress size={24} /> : null}
    >
      {isLoading ? `${children}...` : children}
    </Button>
  );
};
const CustomButton = ({ sx, isLoading, children, ...props }) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        ...sx,
        fontFamily: "Urbane-Light",
        fontSize: "12px",
      }}
    >
      {children}
    </Button>
  );
};

export { LoadingButton, CustomButton };
